export default function removeElement(selector) {
  const element = document.querySelector(selector);
  if (element) {
    element.remove();
  }
}